import React from 'react';

interface Props {
  onClick?: () => void;
  className?: string;
  /** The accessible name, e.g. "Fullscreen" or "Exit fullscreen". */
  ariaLabel?: string;
  /** Shows the exit (corners inward) icon. */
  isFullscreen?: boolean;
}

const FullscreenIcon = ({exit}: {exit?: boolean}) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d={
        exit
          ? 'M5 1V5H1M9 1V5H13M13 9H9V13M1 9H5V13'
          : 'M1 5V1H5M9 1H13V5M13 9V13H9M5 13H1V9'
      }
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PlayerFullscreenButton = ({
  onClick,
  className,
  ariaLabel,
  isFullscreen,
}: Props) => (
  <button
    type="button"
    className={className}
    onClick={onClick}
    aria-label={ariaLabel}>
    <FullscreenIcon exit={isFullscreen} />
  </button>
);

export default PlayerFullscreenButton;
